import React, { useId } from 'react';
import { colors, fontFamily, fontSizes, fontWeights, radii } from '../../theme/tokens';

const TextField = ({ label, prefix, error, hint, id, style, inputStyle, as = 'input', ...inputProps }) => {
  const autoId = useId();
  const inputId = id || 'tf-' + autoId;
  const Field = as;
  const borderColor = error ? colors.danger : colors.softBlue;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, minWidth: 0, ...style }}>
      {label && (
        <label htmlFor={inputId} style={{ fontSize: fontSizes.small + 1, fontWeight: fontWeights.semibold, color: colors.ink }}>
          {label}
        </label>
      )}
      <div
        style={{
          display: 'flex', alignItems: 'stretch', minHeight: 52, boxSizing: 'border-box',
          border: '1.5px solid ' + borderColor, borderRadius: radii.input, background: colors.white, overflow: 'hidden',
        }}
      >
        {prefix && (
          <span
            style={{
              display: 'flex', alignItems: 'center', padding: '0 14px', background: colors.mist,
              color: colors.slate, fontWeight: fontWeights.semibold, fontSize: fontSizes.body,
              borderRight: '1.5px solid ' + borderColor,
            }}
          >
            {prefix}
          </span>
        )}
        <Field
          id={inputId}
          aria-invalid={error ? true : undefined}
          aria-describedby={error ? inputId + '-err' : undefined}
          style={{
            flex: 1, minWidth: 0, border: 0, outline: 'none', background: 'transparent', padding: '12px 16px',
            fontFamily, fontSize: fontSizes.body, color: colors.ink, ...inputStyle,
          }}
          {...inputProps}
        />
      </div>
      {error && (
        <span id={inputId + '-err'} role="alert" style={{ fontSize: fontSizes.small, color: colors.danger }}>{error}</span>
      )}
      {!error && hint && <span style={{ fontSize: fontSizes.small, color: colors.slate }}>{hint}</span>}
    </div>
  );
};

export default TextField;
